import { SPSELECTS } from "InterfacesTypes/enums";
import type { IFooterImages } from "InterfacesTypes/interfaces";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFailure,
  fetchFooterSectionImages,
  fetchStart,
  fetchSuccess,
} from "state/Reducers/FooterSectionImagesReducer";
import { spGet } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();
function* fetchFooterSectionImagesWorker() {
  try {
    yield put(fetchStart());
    const footerSectionsUrl = `${env.listapi}/GetByTitle('FooterSectionImages')/Items?$top=5000&$select=${SPSELECTS.FOOTERSECTIONIMAGES}`;
    const data: IFooterImages[] = yield call(spGet, footerSectionsUrl);
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* footerSectionImagesSaga() {
  yield takeLatest(fetchFooterSectionImages.type, fetchFooterSectionImagesWorker);
}
